import { render, staticRenderFns } from "./modal-task.vue?vue&type=template&id=d5655f98&scoped=true&"
import script from "./modal-task.vue?vue&type=script&lang=ts&"
export * from "./modal-task.vue?vue&type=script&lang=ts&"
import style0 from "./modal-task.vue?vue&type=style&index=0&id=d5655f98&scoped=true&lang=css&"
import style1 from "./modal-task.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5655f98",
  null
  
)

export default component.exports